import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

/**
 * "Tt" icon for normal/paragraph text (matches common editor style for plain text).
 */
export const NormalTextIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g transform="translate(1, 4) scale(0.95)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.813 2.5H0V1h11v1.5H6.313V15h-1.5zM12 6.5V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2V8h-2V6.5z"
        />
      </g>
    </svg>
  );
});

NormalTextIcon.displayName = 'NormalTextIcon';
